import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';

// Components
import { TasksDueComponent } from './tasks-due/components/tasks-due/tasks-due.component';
import { TasksByPracticeAreaComponent } from './tasks-by-practice-area/components/tasks-by-practice-area/tasks-by-practice-area.component';
import { OpenAndClosedRevenuesComponent } from './open-and-closed-revenues/components/open-and-closed-revenues/open-and-closed-revenues.component';
import { ProjectDurationComponent } from './project-duration/components/project-duration/project-duration.component';
import { TasksByLpaComponent } from './tasks-by-lpa/components/tasks-by-lpa/tasks-by-lpa.component';
import { ProjectsByLpaComponent } from './projects-by-lpa/components/projects-by-lpa/projects-by-lpa.component';
import { TimeDistributionComponent } from './time-distribution/components/time-distribution/time-distribution.component';
import { CapacityByPersonComponent } from './capacity-by-person/components/capacity-by-person/capacity-by-person.component';

// Modules
import { CapacityByPersonModule } from './capacity-by-person/capacity-by-person.module';

@NgModule({
    declarations: [
        TasksDueComponent,
        TasksByPracticeAreaComponent,
        OpenAndClosedRevenuesComponent,
        ProjectDurationComponent,
        TasksByLpaComponent,
        ProjectsByLpaComponent,
        TimeDistributionComponent
    ],
    imports: [
        CommonModule,
        NgxChartsModule,
        NgSelectModule,
        FormsModule,
        CalendarModule,
        ButtonModule,
        CapacityByPersonModule
    ],
    exports: [
        TasksDueComponent,
        TasksByPracticeAreaComponent,
        OpenAndClosedRevenuesComponent,
        ProjectDurationComponent,
        TasksByLpaComponent,
        ProjectsByLpaComponent,
        TimeDistributionComponent,
        CapacityByPersonComponent
    ]
})
export class WidgetsModule { }
